import React, { PureComponent } from 'react';

import { createContainer } from '@dbk-legacy/muster/react';
import { View } from 'react-native';
import Text from '@dbk/ui-text';
import Modal from '@dbk/ui-modal';
import Button from '@dbk/ui-buttons';
import { VASCO_MODAL_TYPES } from '../../../constants';

class LogoutConfirmModal extends PureComponent {
  constructor() {
    super();
    this.haveOTP = this.haveOTP.bind(this);
    this.onLogoutDone = this.onLogoutDone.bind(this);
  }

  haveOTP() {
    this.props.auth.setLogoutConfirmVisible(false);
    this.props.setVascoModalType(VASCO_MODAL_TYPES.pin2fa);
  }

  onLogoutDone() {
    this.props.auth.setLogoutConfirmVisible(false);
    this.props.auth.logout();
  }

  render() {
    const { i18n: { messages }, auth: { logoutConfirmVisible } } = this.props;
    const doneLabel = messages['app.common.closeText'];

    return (
      <View>
        <Modal 
          isActive={this.props.auth.logoutConfirmVisible}
          size="small"
          onClose={this.haveOTP}
          className="modal-logout"
          header={messages['app.auth.logoutConfirm.title']}
          content={
            <div className="small-8 row">
                <div className="logout-desc">
              <Text > {messages['app.auth.logoutConfirm.question']} </Text>
            </div>
            <div className="large logout-confirm-btns">
              <div className="logout-button">
                <Button
                  onPress={() => this.onLogoutDone()}
                  tertiary
                  size="small"
                >
                  {messages['app.auth.logoutConfirm.yes']}
                </Button>
              </div>
              <div>
                <Button
                  onPress={() => this.haveOTP()}
                  size="small"
                >
                  {messages['app.auth.logoutConfirm.haveOTP']}
                </Button>
              </div>
            </div>
            </div>
          }
        />
      </View>
    );
  }
}


export default createContainer({
  $queries: {
    auth: {
      setLogoutConfirmVisible: { $call: 'setLogoutConfirmVisible' },
      logoutConfirmVisible: true,
      logout: { $call: 'logout' }
    },
    setVascoModalType: {
      $call: 'vascoauthentication.setVascoModalType',
    },
    i18n: {
      messages: true,
    },
  },
})(LogoutConfirmModal);
